import { useDispatch } from "react-redux";
import { Text, ButtonGroup, IconButton } from "@chakra-ui/react";
import {
  increaseCartQuantity,
  decreaseCartQuantity,
} from "../../redux/actions";

import AddIcon from "../../../src/assets/svg/add_icon";
import LessIcon from "../../../src/assets/svg/less_icon";

export default function Index({ id, quantity }) {
  const dispatch = useDispatch();
  return (
    <ButtonGroup
      size="sm"
      isAttached
      border="1px"
      borderRadius={4}
      variant="unstyled"
      borderColor="cartItemBorder"
    >
      <IconButton
        ml={3}
        aria-label="Remove from cart"
        disabled={quantity === 1 && true}
        onClick={() => dispatch(decreaseCartQuantity(id))}
        icon={<LessIcon height="20" width="20" color="#49586B" />}
      />
      <Text mt={1} variant="cartRegular">
        {quantity}
      </Text>
      <IconButton
        ml={3}
        aria-label="Add to cart"
        onClick={() => dispatch(increaseCartQuantity(id))}
        icon={<AddIcon width="20" height="20" color="#49586B" />}
      />
    </ButtonGroup>
  );
}
